export default __webpack_public_path__ + "static/media/CIHE_Composicion_sola5.87dd7f2c.jpg";